import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    NbButton,
    NbButtonModule,
    NbCardModule,
    NbDatepickerModule,
    NbDateTimePickerComponent,
    NbInputModule,
    NbLayoutModule,
    NbMenuModule,
    NbSidebarModule,
    NbTimepickerModule,
} from "@nebular/theme";
import { ThemeModule } from "../@theme/theme.module";
import { DemoApplyComponent } from "./demo-apply.component";
import { DemoApplyRoutingModule } from "./demo-apply-routing.module";
import { DemoApplyLayoutComponent } from "./demo-apply.layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxGalleryModule } from "@kolkov/ngx-gallery";

@NgModule({
    declarations: [DemoApplyComponent, DemoApplyLayoutComponent],
    imports: [
        CommonModule,
        NbSidebarModule,
        NbMenuModule,
        NbLayoutModule,
        ThemeModule,
        NbCardModule,
        NbButtonModule,
        NbInputModule,
        FormsModule,
        ReactiveFormsModule,
        DemoApplyRoutingModule,
        NgxGalleryModule,
        NbDatepickerModule.forRoot(),
        NbTimepickerModule.forRoot(),
    ],
})
export class DemoApplyModule {}
